type IconProps = {
  className?: string;
};

export function EyeIcon({ className = "h-5 w-5" }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M8.12508 10C8.12508 8.96448 8.96455 8.12501 10.0001 8.12501C11.0356 8.12501 11.8751 8.96448 11.8751 10C11.8751 11.0355 11.0356 11.875 10.0001 11.875C8.96455 11.875 8.12508 11.0355 8.12508 10Z"
        fill="#02040A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66675 10C1.66675 11.3662 2.02088 11.8262 2.72916 12.7464C4.14339 14.5837 6.51518 16.6667 10.0001 16.6667C13.485 16.6667 15.8568 14.5837 17.271 12.7464C17.9793 11.8262 18.3334 11.3662 18.3334 10C18.3334 8.63386 17.9793 8.17378 17.271 7.25362C15.8568 5.41631 13.485 3.33334 10.0001 3.33334C6.51518 3.33334 4.14338 5.41631 2.72916 7.25362C2.02088 8.17378 1.66675 8.63386 1.66675 10ZM10.0001 6.87501C8.27419 6.87501 6.87508 8.27412 6.87508 10C6.87508 11.7259 8.27419 13.125 10.0001 13.125C11.726 13.125 13.1251 11.7259 13.1251 10C13.1251 8.27412 11.726 6.87501 10.0001 6.87501Z"
        fill="#02040A"
      />
    </svg>
  );
}

export function ChatIcon({ className = "h-5 w-5" }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M18.3334 7.08332C18.3334 4.09178 15.9083 1.66666 12.9167 1.66666C11.181 1.66666 9.63598 2.48524 8.64467 3.756C12.8727 3.91946 16.2501 7.39864 16.2501 11.6667C16.2501 11.7586 16.2485 11.8501 16.2454 11.9413L16.5223 12.0154C17.3276 12.2309 18.0643 11.4941 17.8488 10.6889L17.7427 10.2922C17.6569 9.97171 17.7085 9.63316 17.8463 9.33142C18.1591 8.64665 18.3334 7.88534 18.3334 7.08332Z"
        fill="#222A3D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0001 11.6667C15.0001 15.3486 12.0153 18.3333 8.33341 18.3333C7.30383 18.3333 6.32875 18.0999 5.45821 17.6832C5.159 17.5399 4.82003 17.4896 4.49957 17.5754L3.47787 17.8487C2.67259 18.0642 1.93588 17.3275 2.15134 16.5222L2.42471 15.5005C2.51045 15.18 2.46016 14.8411 2.31691 14.5419C1.90014 13.6713 1.66675 12.6962 1.66675 11.6667C1.66675 7.98476 4.65152 4.99999 8.33341 4.99999C12.0153 4.99999 15.0001 7.98476 15.0001 11.6667ZM5.41675 12.5C5.87699 12.5 6.25008 12.1269 6.25008 11.6667C6.25008 11.2064 5.87699 10.8333 5.41675 10.8333C4.95651 10.8333 4.58341 11.2064 4.58341 11.6667C4.58341 12.1269 4.95651 12.5 5.41675 12.5ZM8.33341 12.5C8.79365 12.5 9.16675 12.1269 9.16675 11.6667C9.16675 11.2064 8.79365 10.8333 8.33341 10.8333C7.87318 10.8333 7.50008 11.2064 7.50008 11.6667C7.50008 12.1269 7.87318 12.5 8.33341 12.5ZM11.2501 12.5C11.7103 12.5 12.0834 12.1269 12.0834 11.6667C12.0834 11.2064 11.7103 10.8333 11.2501 10.8333C10.7898 10.8333 10.4167 11.2064 10.4167 11.6667C10.4167 12.1269 10.7898 12.5 11.2501 12.5Z"
        fill="#02040A"
      />
    </svg>
  );
}

export function AssignIcon({ className = "h-5 w-5" }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="10" cy="6" r="4" fill="#222A3D" />
      <path
        d="M18 17.5C18 19.9853 18 22 10 22C2 22 2 19.9853 2 17.5C2 15.0147 5.58172 13 10 13C14.4183 13 18 15.0147 18 17.5Z"
        fill="#222A3D"
      />
      <path
        d="M21 10H19M19 10H17M19 10L19 8M19 10L19 12"
        stroke="#222A3D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function PersonIcon({ className = "h-4 w-4" }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="7.99992" cy="3.99999" r="2.66667" stroke="currentColor" />
      <path
        d="M13.3334 11.6667C13.3334 13.3235 13.3334 14.6667 8.00008 14.6667C2.66675 14.6667 2.66675 13.3235 2.66675 11.6667C2.66675 10.0098 5.05456 8.66667 8.00008 8.66667C10.9456 8.66667 13.3334 10.0098 13.3334 11.6667Z"
        stroke="currentColor"
      />
    </svg>
  );
}

export function AddPatientIcon({ className = "h-5 w-5" }: IconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <g clipPath="url(#add_patient_icon_clip)">
        <circle cx="7.99992" cy="7.99999" r="6.66667" stroke="currentColor" />
        <path
          d="M10 8.00002L8 8.00002M8 8.00002L6 8.00002M8 8.00002L8 6M8 8.00002L8 10"
          stroke="currentColor"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="add_patient_icon_clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
